export default __webpack_public_path__ + "static/media/web.b2124904.png";